@if (loading$ | async) {
  <span class="credit-badge credit-badge--skeleton credit-badge--loading">
    <span class="credit-badge__icon credit-badge__icon--loading">
      <lucide-icon name="loader-circle" [size]="12" />
    </span>
    <span class="credit-badge__value">···</span>
  </span>
} @else if (wallet) {
  <button
    class="credit-badge"
    [class.credit-badge--danger]="wallet.isOverconsuming"
    (click)="navigate()"
    type="button"
  >
    <span class="credit-badge__icon">
      <lucide-icon name="dollar-sign" [size]="12" />
    </span>
    <span class="credit-badge__value">{{ formattedValue }}</span>
  </button>
} @else if (!walletChecked) {
  <span class="credit-badge credit-badge--skeleton">
    <span class="credit-badge__icon">
      <lucide-icon name="dollar-sign" [size]="12" />
    </span>
    <span class="credit-badge__value">···</span>
  </span>
}
<!-- walletChecked && !wallet → no wallet for this tenant, render nothing -->
